import { getConfig } from '@superbet-group/web.lib.config';
import { Store } from 'vuex';

import { authenticationService } from '@core/services/authentication/AuthenticationService';
import { SET_USER } from '@store/modules/data/authentication/mutationTypes';

import {
    createCheckLoginSessionWorker,
    createSessionActivityJob,
} from './jobs/sessionActivity';
import { createSessionDurationJob } from './jobs/sessionDurationModal';
import { ScheduledJob } from './types';

const activeBackgroundJobs: ScheduledJob[] = [];
const isAutoLogoutEnabled = !!getConfig().countrySpecific.isAutoLogoutEnabled;

export function initializeBackgroundJobs(store: Store<any>) {
    if (!isAutoLogoutEnabled && getConfig().countrySpecific.isSessionDurationDisplayed) {
        activeBackgroundJobs.push(createSessionDurationJob(store));
    }
    if (getConfig().countrySpecific.useSessionActivity) {
        activeBackgroundJobs.push(
            createSessionActivityJob(createCheckLoginSessionWorker({
                authenticationService,
                store,
                isAutoLogoutEnabled,
            })),
        );
    }
}

export function subscribeToUser(store: Store<any>) {
    store.subscribe((mutation) => {
        if (mutation.type === `data/authentication/${SET_USER}`) {
            if (mutation.payload !== null) {
                activeBackgroundJobs.forEach((job: ScheduledJob) => job.start());
            } else {
                activeBackgroundJobs.forEach((job: ScheduledJob) => job.destroy());
            }
        }
    });
}
